// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
 * CRM Filter Awareness — Shared styles for ALL CRM pages
 * Sticky/floating banner + dismissible filter chips.
 * Import once in src/index.css (already wired).
 * ============================================================ */

/* ── Sticky stack wrapper ─────────────────────────────────────
 * Stays "floating" at top of viewport while user scrolls through
 * the rest of the page. Solid white card with drop shadow so it
 * never visually merges into content scrolling beneath it.
 */
.crm-filter-sticky-stack {
  position: sticky;
  top: 0;
  z-index: 1020;
  margin: 0 0 18px;
  padding: 8px 0 4px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.98) 78%,
    rgba(255, 255, 255, 0) 100%
  );
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

/* When the sticky element is "stuck" we want a stronger separation.
 * CSS \`position: sticky\` doesn't expose a stuck state, but the gradient
 * fade above keeps text legible regardless.
 */

/* ── Awareness banner card ────────────────────────────────── */
.crm-awareness-bar {
  display: flex;
  gap: 16px;
  margin-bottom: 10px;
  padding: 14px 18px;
  border-radius: 20px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  background: linear-gradient(
    135deg,
    rgba(248, 250, 252, 0.99),
    rgba(239, 246, 255, 0.97)
  );
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.1);
}

.crm-awareness-copy {
  min-width: 0;
  flex: 1 1;
}

/* ── Kicker row (dot + "Data Filter" label) ───────────────── */
.crm-awareness-kicker {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #0369a1;
  margin-bottom: 4px;
}

/* ── Pulsing dot ──────────────────────────────────────────── */
.crm-awareness-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #14b8a6;
  box-shadow: 0 0 0 6px rgba(20, 184, 166, 0.12);
  flex-shrink: 0;
}

.crm-awareness-dot.is-loading {
  background: #f97316;
  box-shadow: 0 0 0 6px rgba(249, 115, 22, 0.14);
  animation: crmPulse 1.2s ease-in-out infinite;
}

@keyframes crmPulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.3);
  }
}

/* ── Text rows ────────────────────────────────────────────── */
.crm-awareness-title {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
  line-height: 1.35;
}

.crm-awareness-summary {
  font-size: 13px;
  color: #334155;
  line-height: 1.6;
}

.crm-awareness-detail {
  margin-top: 6px;
  font-size: 12px;
  color: #475569;
  line-height: 1.5;
  word-break: break-word;
}

/* ── Filter chips row ─────────────────────────────────────── */
.crm-filter-chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 0 2px 10px;
}

.crm-filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid #cbd5e1;
  background: #f8fafc;
  font-size: 12px;
  font-weight: 500;
  color: #334155;
  transition: background 0.15s ease, border-color 0.15s ease;
  max-width: 100%;
}

.crm-filter-chip:hover {
  background: #f1f5f9;
  border-color: #94a3b8;
}

.crm-filter-chip-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  padding: 0;
  width: 14px;
  height: 14px;
  line-height: 1;
  font-size: 14px;
  color: #94a3b8;
  cursor: pointer;
  transition: color 0.15s ease;
}

.crm-filter-chip-remove:hover {
  color: #ef4444;
}

.crm-filter-chip-reset {
  border: none;
  background: none;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  color: #0369a1;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.15s ease;
}

.crm-filter-chip-reset:hover {
  color: #0284c7;
}

/* ─────────────────────────────────────────────────────────────
 * Mobile responsiveness — collapse padding & font scale at <576px
 * ───────────────────────────────────────────────────────────── */
@media (max-width: 992px) {
  .crm-filter-sticky-stack {
    top: 64px; /* matches .mobile-navbar height in layout.css */
  }
}

@media (max-width: 768px) {
  .crm-filter-sticky-stack {
    margin-bottom: 12px;
    padding-top: 6px;
  }
  .crm-awareness-bar {
    padding: 12px 14px;
    border-radius: 16px;
    gap: 10px;
  }
  .crm-awareness-title {
    font-size: 0.95rem;
  }
  .crm-awareness-summary {
    font-size: 12.5px;
  }
  .crm-awareness-detail {
    font-size: 11.5px;
  }
}

@media (max-width: 480px) {
  .crm-filter-chips {
    padding-bottom: 8px;
  }
  .crm-filter-chip {
    font-size: 11px;
    padding: 3px 8px;
  }
}

/* ─────────────────────────────────────────────────────────────
 * AdvancedFilterPanel offcanvas — responsive width
 * Desktop: 380px panel slides in from right.
 * Tablet:  360px.
 * Mobile:  92vw (full-screen-feel with breathing edge).
 * ───────────────────────────────────────────────────────────── */
.crm-advanced-filter-offcanvas {
  width: 380px;
  max-width: 100vw;
}

@media (max-width: 768px) {
  .crm-advanced-filter-offcanvas {
    width: 360px;
  }
}

@media (max-width: 576px) {
  .crm-advanced-filter-offcanvas {
    width: 92vw;
    max-width: 92vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/AdvancedFilter/FilterAwarenessBar.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;;;;EAIE;AACF;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB;;;;;GAKC;EACD,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;;;EAGE;;AAEF,gEAAgE;AAChE;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C;;;;GAIC;EACD,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA,gEAAgE;AAChE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA,gEAAgE;AAChE;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,6CAA6C;AAC/C;;AAEA;EACE;;IAEE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA,gEAAgE;AAChE;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0DAA0D;EAC1D,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;;kEAEkE;AAClE;EACE;IACE,SAAS,EAAE,gDAAgD;EAC7D;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;;;;;kEAKkE;AAClE;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":["/* ============================================================\n * CRM Filter Awareness — Shared styles for ALL CRM pages\n * Sticky/floating banner + dismissible filter chips.\n * Import once in src/index.css (already wired).\n * ============================================================ */\n\n/* ── Sticky stack wrapper ─────────────────────────────────────\n * Stays \"floating\" at top of viewport while user scrolls through\n * the rest of the page. Solid white card with drop shadow so it\n * never visually merges into content scrolling beneath it.\n */\n.crm-filter-sticky-stack {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n  margin: 0 0 18px;\n  padding: 8px 0 4px;\n  background: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 1) 0%,\n    rgba(255, 255, 255, 0.98) 78%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n}\n\n/* When the sticky element is \"stuck\" we want a stronger separation.\n * CSS `position: sticky` doesn't expose a stuck state, but the gradient\n * fade above keeps text legible regardless.\n */\n\n/* ── Awareness banner card ────────────────────────────────── */\n.crm-awareness-bar {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 10px;\n  padding: 14px 18px;\n  border-radius: 20px;\n  border: 1px solid rgba(148, 163, 184, 0.22);\n  background: linear-gradient(\n    135deg,\n    rgba(248, 250, 252, 0.99),\n    rgba(239, 246, 255, 0.97)\n  );\n  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.1);\n}\n\n.crm-awareness-copy {\n  min-width: 0;\n  flex: 1;\n}\n\n/* ── Kicker row (dot + \"Data Filter\" label) ───────────────── */\n.crm-awareness-kicker {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #0369a1;\n  margin-bottom: 4px;\n}\n\n/* ── Pulsing dot ──────────────────────────────────────────── */\n.crm-awareness-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: #14b8a6;\n  box-shadow: 0 0 0 6px rgba(20, 184, 166, 0.12);\n  flex-shrink: 0;\n}\n\n.crm-awareness-dot.is-loading {\n  background: #f97316;\n  box-shadow: 0 0 0 6px rgba(249, 115, 22, 0.14);\n  animation: crmPulse 1.2s ease-in-out infinite;\n}\n\n@keyframes crmPulse {\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.6;\n    transform: scale(1.3);\n  }\n}\n\n/* ── Text rows ────────────────────────────────────────────── */\n.crm-awareness-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 4px;\n  line-height: 1.35;\n}\n\n.crm-awareness-summary {\n  font-size: 13px;\n  color: #334155;\n  line-height: 1.6;\n}\n\n.crm-awareness-detail {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #475569;\n  line-height: 1.5;\n  word-break: break-word;\n}\n\n/* ── Filter chips row ─────────────────────────────────────── */\n.crm-filter-chips {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  padding: 0 2px 10px;\n}\n\n.crm-filter-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  border: 1px solid #cbd5e1;\n  background: #f8fafc;\n  font-size: 12px;\n  font-weight: 500;\n  color: #334155;\n  transition: background 0.15s ease, border-color 0.15s ease;\n  max-width: 100%;\n}\n\n.crm-filter-chip:hover {\n  background: #f1f5f9;\n  border-color: #94a3b8;\n}\n\n.crm-filter-chip-remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: none;\n  padding: 0;\n  width: 14px;\n  height: 14px;\n  line-height: 1;\n  font-size: 14px;\n  color: #94a3b8;\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n\n.crm-filter-chip-remove:hover {\n  color: #ef4444;\n}\n\n.crm-filter-chip-reset {\n  border: none;\n  background: none;\n  padding: 4px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #0369a1;\n  cursor: pointer;\n  text-decoration: underline;\n  transition: color 0.15s ease;\n}\n\n.crm-filter-chip-reset:hover {\n  color: #0284c7;\n}\n\n/* ─────────────────────────────────────────────────────────────\n * Mobile responsiveness — collapse padding & font scale at <576px\n * ───────────────────────────────────────────────────────────── */\n@media (max-width: 992px) {\n  .crm-filter-sticky-stack {\n    top: 64px; /* matches .mobile-navbar height in layout.css */\n  }\n}\n\n@media (max-width: 768px) {\n  .crm-filter-sticky-stack {\n    margin-bottom: 12px;\n    padding-top: 6px;\n  }\n  .crm-awareness-bar {\n    padding: 12px 14px;\n    border-radius: 16px;\n    gap: 10px;\n  }\n  .crm-awareness-title {\n    font-size: 0.95rem;\n  }\n  .crm-awareness-summary {\n    font-size: 12.5px;\n  }\n  .crm-awareness-detail {\n    font-size: 11.5px;\n  }\n}\n\n@media (max-width: 480px) {\n  .crm-filter-chips {\n    padding-bottom: 8px;\n  }\n  .crm-filter-chip {\n    font-size: 11px;\n    padding: 3px 8px;\n  }\n}\n\n/* ─────────────────────────────────────────────────────────────\n * AdvancedFilterPanel offcanvas — responsive width\n * Desktop: 380px panel slides in from right.\n * Tablet:  360px.\n * Mobile:  92vw (full-screen-feel with breathing edge).\n * ───────────────────────────────────────────────────────────── */\n.crm-advanced-filter-offcanvas {\n  width: 380px;\n  max-width: 100vw;\n}\n\n@media (max-width: 768px) {\n  .crm-advanced-filter-offcanvas {\n    width: 360px;\n  }\n}\n\n@media (max-width: 576px) {\n  .crm-advanced-filter-offcanvas {\n    width: 92vw;\n    max-width: 92vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
